{% block sw_order_detail_details_custom_fields %}
    {% parent %}
    <sw-order-detail-revocation :order-id="$route.params.id" :order-number="order ? order.orderNumber : null" />
{% endblock %}
